/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Promo_Holdings_ReceivedInputs */



/**
* | output |
* | --- |
* | "{count} received" |
*
* @param {Promo_Holdings_ReceivedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_holdings_received = /** @type {((inputs: Promo_Holdings_ReceivedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Holdings_ReceivedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} reçue(s)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} recibida(s)`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} recebida(s)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} ricevuta/e`)
	return /** @type {LocalizedString} */ (`${i?.count} received`)
});